import vx from 'vx'
import VueI18n from 'vue-i18n';
import zh_CN from 'vee-validate/dist/locale/zh_CN';
import VeeValidate from 'vee-validate';
import Ruler from './rules'
import attributes from './attributes'

const { Validator } = VeeValidate;

vx.use(VueI18n);
const i18n = new VueI18n({
  locale: 'zh_CN',
});

vx.use(VeeValidate, {
  events: 'blur',
  i18n,
  i18nRootKey: 'validation',
  dictionary: {
    zh_CN
  }
});

const dictionary = {
  zh_CN: {
    messages: {
      required: (name) => `请输入${name}`
    },
    attributes
  }
};

// Override and merge the dictionaries
Validator.localize(dictionary);

//自定义规则
Validator.extend('idCard',Ruler.idCard);
Validator.extend('phone',Ruler.phone);
Validator.extend('captcha',Ruler.captcha);



// WEBPACK FOOTER //
// ./src/plugins/vee-validate/index.js